import React, { useState, useEffect } from 'react';

import fallbackImg from '../../assets/images/rings.svg';

interface ImageWithPlaceholder {
    src: string;
    setIsImageLoaded?: (boolean) => void;
}

const ImageWithPlaceholder = React.memo(({ src, setIsImageLoaded }: ImageWithPlaceholder) => {
    const [showPlaceholder, setShowPlaceholder] = useState(null);

    useEffect(() => {
        const imageToLoad = new Image();
        imageToLoad.src = src;
        imageToLoad.onload = () => {
            if (setIsImageLoaded) {
                setIsImageLoaded(true);
            }
        };
        imageToLoad.onerror = () => {
            setShowPlaceholder(true);
        };
    }, [src]);

    return <img src={showPlaceholder ? fallbackImg?.src || fallbackImg : src} className={showPlaceholder ? 'image-placeholder' : ''} />;
});

export default ImageWithPlaceholder;
